import { KnowledgeResourceType } from '../../core/models';

const RESOURCE_TYPE_LABELS: Record<KnowledgeResourceType, string> = {
  ARTICLE: 'Article',
  GUIDE: 'Guide',
  TRAINING_SUPPORT: 'Support de formation',
  VIDEO: 'Vidéo',
  FAQ: 'FAQ',
  PROCEDURE: 'Procédure',
  TEMPLATE: 'Modèle',
};

/** `resourceType` est un champ texte libre côté backend : replie sur la valeur brute si inconnue. */
export function resourceTypeLabel(resourceType: string): string {
  return RESOURCE_TYPE_LABELS[resourceType as KnowledgeResourceType] ?? resourceType;
}

/** Clé i18n (`pages.documentation.resourceTypes.*`, public/i18n/*.json) pour un type connu, sinon null (repli sur `resourceTypeLabel`). */
export function resourceTypeLabelKey(resourceType: string): string | null {
  if (!(resourceType in RESOURCE_TYPE_LABELS)) return null;
  return `pages.documentation.resourceTypes.${resourceType.toLowerCase()}`;
}
